// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.
export const environment = {
    production: false,
    hmr: false,

    name: 'DESARROLLO', 

    urlEsErpAccesos: 'https://prod-apies-accesos.herokuapp.com',
    //urlEsErpAccesos: 'http://localhost:3010',
    //urlEsErpInventarioMantenedor: 'http://localhost:3005',
    urlEsErpInventarioMantenedor: 'https://prod-apies-inventario.herokuapp.com',
    //urlEsErpVentaNota: 'http://localhost:3014',
    urlEsErpVentaNota: 'https://prod-apies-venta.herokuapp.com', 
    //urlEsErpCompraCliente: 'http://localhost:3002',
    urlEsErpCompraCliente: 'https://prod-apies-compra.herokuapp.com',
    urlEsErpSunatHeroku: 'https://prod-apies-sunat-notificacion.herokuapp.com',
    //urlEsErpSunatHeroku: 'https://localhost:44354',
    urlEsErpReportePython: 'https://reporte-prueba2.fly.dev'
    //urlEsErpReportePython: 'http://192.168.1.10:5000'
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular 
